import { AdScriptBanner } from '@/components/AdScriptBanner';

export const AdsterraAd = () => {
  // 320x50 mobile banner ad
  return (
    <div className="overflow-x-auto">
      <div className="flex justify-center">
        <AdScriptBanner
          atKey="44442e2b6d5759bbd095a7b64540e80d"
          scriptSrc="https://sulkweapon.com/44442e2b6d5759bbd095a7b64540e80d/invoke.js"
          width={320}
          height={50}
        />
      </div>
    </div>
  );
};